import http from '@/utils/http'

// URL and endpoint constants
const API_URL = process.env.API_BASE_URL

// Send a request to the login URL. When using JWT, will just probably uncomment these lines
// const login = (creds) => {
//   let token = btoa(creds.name + ':' + creds.password)
//   let config = {
//     method: 'post',
//     url: LOGIN_URL,
//     responseType: 'json',
//     headers: {
//       'Authorization': 'Basic ' + token
//     },
//     credentials: true
//   }
//   return http(config)
// }

const getAutenticacaoUsuario = () => {
  let config = {
    method: 'get',
    url: API_URL + 'auth',
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getPermissoesUsuario = () => {
  let config = {
    method: 'get',
    url: API_URL + 'auth/permissoes',
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const getConfiguracoesUsuario = () => {
  let config = {
    method: 'get',
    url: API_URL + 'auth/configuracoes',
    responseType: 'json',
    credentials: true
  }
  return http(config)
}

const alterarConfiguracoesUsuario = (payload) => {
  let config = {
    method: 'post',
    url: API_URL + 'auth/configuracoes',
    responseType: 'json',
    credentials: true,
    body: payload
  }
  return http(config)
}

export default {
  getAutenticacaoUsuario,
  getPermissoesUsuario,
  getConfiguracoesUsuario,
  alterarConfiguracoesUsuario
}
